import React, { useEffect, useState, useRef } from "react";
import { Card, Button, Row, Col, Modal } from "react-bootstrap";
import { Link, redirect, useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getTutorialSteps,
  fetchRestaurantDetails,
  updateRestaurant,
  createRestaurant,
} from "../actions/restaurantActions";
import Loader from "../components/Loader";
import Messages from "../components/Messages";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleArrowRight,
  faCircleArrowLeft,
  faPlus,
  faXmark,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import TutorialSteps from "../components/TutorialSteps";
import AutoFillAddress from "../components/AutoFillAddress";
import FiscalAdress from "./FiscalAdress";
import DropDownButton from "../components/DropDownButton";
import StripePay from "../components/StripePay";
import PhoneField from "../components/PhoneField";
/* global google */
import {
  ErrorMessageBox,
  CloseIcon,
  ConfirmationModal,
  ModalOverlay,
  ModernButton,
} from "../components/DefaultImports";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

// Styled Components...

const TutorialBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 505px;
  position: relative;
  min-height: 600px;
  overflow: hidden;
`;

const TutorialBoxContent = styled.div`
  width: 100%;
  padding: 1.5rem;
  overflow-y: auto;
  margin-top: -15px;
`;

const TutorialBoxText = styled.div`
  font-size: 2.2rem;
  font-weight: 700;
  color: #222;
  text-align: center;
  width: 100%;
  margin-bottom: 40px;
  border-bottom: 2px solid #ee561b;
  padding-bottom: 10px;
`;

const TutorialBoxMiddleSteps = styled.div`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.9rem;
  color: #999;
  font-weight: 500;
  letter-spacing: 0.4px;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 14px 18px;
  margin-bottom: 24px;
  font-size: 16px;
  border: 1px solid ${(props) => (props.invalid ? "#dc3545" : "#ddd")};
  border-radius: 10px;
  background-color: #fafafa;
  transition: all 0.2s ease;
  &:focus {
    border-color: ${(props) => (props.invalid ? "#dc3545" : "#de8c3a")};
    background-color: #fff;
    box-shadow: ${(props) =>
      props.invalid
        ? "0 0 0 4px rgba(220, 53, 69, 0.15)"
        : "0 0 0 4px rgba(222, 140, 58, 0.15)"};
    outline: none;
  }
  &::placeholder {
    color: #aaa;
  }
`;

const CreateButtom = styled.div`
  padding: 10px 15px;
  background-color: #ee561b;
  color: #faf6e9;
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  position: absolute;
  bottom: 5px;
  right: 12px;
  transition: background 0.3s ease, transform 0.2s;
  &:hover {
    background-color: #cc7a2d;
    transform: translateY(-2px);
  }
`;

const StyledArrowRight = styled(FontAwesomeIcon)`
  position: absolute;
  bottom: 5px;
  right: 24px;
  font-size: 2rem;
  color: #99b0ad;
  cursor: pointer;
  transition: transform 0.2s ease;
  &:hover {
    transform: scale(1.1);
    color: #99b0ad;
  }
`;

const StyledArrowLeft = styled(FontAwesomeIcon)`
  position: absolute;
  bottom: 5px;
  left: 24px;
  font-size: 2rem;
  color: #99b0ad;
  cursor: pointer;
  transition: transform 0.2s ease;
  &:hover {
    transform: scale(1.1);
    color: #99b0ad;
  }
`;

const StyledH5 = styled.h5`
  font-size: 16px;
  font-weight: 600;
  color: #99b0ad;
  width: 100%;
  text-align: left;
  margin-bottom: 12px;
  margin-top: 0;
`;

const getTimezone = () => {
  if (window.Intl && window.Intl.DateTimeFormat) {
    const options = new window.Intl.DateTimeFormat().resolvedOptions();
    return options?.timeZone || "";
  }
  return "";
};

function RestaurantCreation({ setRestauranteCreationModal }) {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addressInputRef = useRef("");

  const [currentStep, setCurrentStep] = useState("name");
  const [stepCounter, setStepCounter] = useState(1);
  const [showStepsModal, setShowStepsModal] = useState(
    params.tutorial === "yes"
  );
  const [restaurantName, setRestaurantName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [country, setCountry] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [locality, setLocality] = useState("");
  const [longitudeField, setLongitudeField] = useState(false);
  const [latitudeField, setLatitudeField] = useState(false);
  const [address, setAddress] = useState("");
  const [timezone, setTimezone] = useState(getTimezone());
  const [fiscalAdressId, setFiscalAdressId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [isCreateRestaurant, setIsCreateRestaurant] = useState(false);
  const [countryCodeNumber, setCountryCodeNumber] = useState("351");
  const [phoneWithoutCountryCode, setPhoneWithoutCountryCode] = useState("");
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [showConfirmExit, setShowConfirmExit] = useState(false);

  const tutorial_steps_list = useSelector((state) => state.tutorial_steps);
  const { tutorialSteps, isLoadingTutorialSteps, tutorialStepsError } =
    tutorial_steps_list;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const created_restaurant = useSelector((state) => state.create_a_restaurant);
  const {
    createRestaurant: myCustomCreateRestaurant,
    isLoadingCreateRestaurant,
  } = created_restaurant;
  const paymentIntentInfo = useSelector((state) => state.paymentIntent);
  const { paymentIntent } = paymentIntentInfo;

  const { isLoaded: isGoogleLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyA7wQgzKIx0-y6j3pfy341jX6LmYq5_Sc4",
  });

  const [marker, setMarker] = useState(false);
  const [invalidFields, setInvalidFields] = useState([]);

  useEffect(() => {
    dispatch(createRestaurant("", true));
  }, []);

  useEffect(() => {
    dispatch(getTutorialSteps(currentStep));
  }, [currentStep]);

  useEffect(() => {
    if (myCustomCreateRestaurant && isCreateRestaurant) {
      navigate(`/choose_plan_and_pay/${myCustomCreateRestaurant.id}`);
    }
  }, [myCustomCreateRestaurant, isLoadingCreateRestaurant]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const query = [address, postalCode, locality, country]
        .filter(Boolean)
        .join(", ");
      if (!query || !isGoogleLoaded) {
        setLatitudeField(false);
        setLongitudeField(false);
        setMarker(false);
        return;
      }
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: query }, (results, status) => {
        if (status === "OK" && results.length > 0) {
          const location = results[0].geometry.location;
          setLatitudeField(location.lat());
          setLongitudeField(location.lng());
          setMarker({ lat: location.lat(), lng: location.lng() });
        }
      });
    }, 500);

    return () => clearTimeout(timeout);
  }, [address, postalCode, locality, country, isGoogleLoaded]);

  const onMapClick = React.useCallback((event) => {
    setMarker({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    });
    setLatitudeField(event.latLng.lat());
    setLongitudeField(event.latLng.lng());
  }, []);

  function validateRestaurantFields(currentStep, fields) {
    let requiredFields = [];

    if (currentStep === "name") {
      requiredFields = [
        {
          key: "restaurantName",
          label: "Nome do restaurante",
          value: fields.restaurantName,
        },
      ];
    } else if (currentStep === "adress") {
      requiredFields = [
        { key: "country", label: "País", value: fields.country },
        { key: "address", label: "Morada", value: fields.address },
        {
          key: "postal_code",
          label: "Código Postal",
          value: fields.postalCode,
        },
        { key: "locality", label: "Localidade", value: fields.locality },
      ];
    } else if (currentStep === "fiscal_address") {
      requiredFields = [
        {
          key: "fiscalAdressId",
          label: "Perfil fiscal",
          value: fields.fiscalAdressId,
        },
      ];
    }

    const missingFields = requiredFields.filter((field) => !field.value);
    const labels = missingFields.map((field) => field.label);
    const keys = missingFields.map((field) => field.key);

    if (labels.length > 0) {
      return {
        status: `Por favor, preencha: ${labels.join(", ")}`,
        invalidKeys: keys,
      };
    }
    return { status: "ok_status", invalidKeys: [] };
  }

  function checkForErrorsAndCreateRestaurant() {
    const fields = {
      restaurantName,
      isPhoneValid,
      address,
      postalCode,
      locality,
      country,
      fiscalAdressId,
    };

    const validationResult = validateRestaurantFields(currentStep, fields);
    setErrorMessage(validationResult.status);
    setInvalidFields(validationResult.invalidKeys);

    if (validationResult.status === "ok_status") {
      setShowError(false);
      const updatedRestaurantParams = {
        restaurant_name: restaurantName,
        phone_number: phoneWithoutCountryCode,
        country_code: countryCodeNumber,
        postal_code: postalCode,
        locality: locality,
        latitude: latitudeField,
        longitude: longitudeField,
        adress: address,
        country: country,
        fiscal_information: fiscalAdressId,
        timezone: timezone,
      };
      dispatch(createRestaurant(updatedRestaurantParams));
      setIsCreateRestaurant(true);
    } else {
      setShowError(true);
    }
  }

  const handleNextSteps = () => {
    const fields = {
      restaurantName,
      isPhoneValid,
      address,
      postalCode,
      locality,
      country,
      fiscalAdressId,
    };

    const validationResult = validateRestaurantFields(currentStep, fields);

    if (validationResult.status !== "ok_status") {
      setErrorMessage(validationResult.status);
      setInvalidFields(validationResult.invalidKeys);
      return;
    }

    setErrorMessage("");
    setStepCounter((prev) => prev + 1);

    switch (stepCounter + 1) {
      case 2:
        setCurrentStep("adress");
        break;
      case 3:
        setCurrentStep("fiscal_address");
        break;
      case 4:
        setCurrentStep("payment");
        break;
      default:
        setCurrentStep("name");
    }
  };

  const handleGoBackSteps = () => {
    setStepCounter((prev) => prev - 1);

    switch (stepCounter - 1) {
      case 1:
        setCurrentStep("name");
        break;
      case 2:
        setCurrentStep("adress");
        break;
      case 3:
        setCurrentStep("fiscal_address");
        break;
      default:
        setCurrentStep("name");
    }
  };

  const handleCloseStepsModal = () => setShowStepsModal(false);

  return (
    <TutorialBox>
      <TutorialBoxContent>
        {/* Step Contents */}
        {currentStep === "name" && (
          <>
            <StyledH5>Nome</StyledH5>
            <StyledInput
              type="text"
              value={restaurantName}
              placeholder="Nome do restaurante"
              onChange={(e) => setRestaurantName(e.target.value)}
              invalid={invalidFields.includes("restaurantName")}
            />
            <StyledH5>Número de telemóvel (opcional)</StyledH5>
            <PhoneField
              countryCodeNumber={countryCodeNumber}
              setCountryCodeNumber={setCountryCodeNumber}
              phoneWithoutCountryCode={phoneWithoutCountryCode}
              setPhoneWithoutCountryCode={setPhoneWithoutCountryCode}
              isPhoneValid={isPhoneValid}
              setIsPhoneValid={setIsPhoneValid}
            />
          </>
        )}
        {currentStep === "adress" && (
          <>
            <StyledH5>Morada</StyledH5>
            <StyledInput
              type="text"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              placeholder="País"
              invalid={invalidFields.includes("country")}
            />
            <StyledInput
              type="text"
              ref={addressInputRef}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="Morada"
              autoComplete="nope"
              invalid={invalidFields.includes("address")}
            />
            <Row>
              <Col xs={5}>
                <StyledInput
                  type="text"
                  value={postalCode}
                  onChange={(e) => setPostalCode(e.target.value)}
                  placeholder="Código Postal"
                  invalid={invalidFields.includes("postal_code")}
                />
              </Col>
              <Col xs={7}>
                <StyledInput
                  type="text"
                  value={locality}
                  onChange={(e) => setLocality(e.target.value)}
                  placeholder="Localidade"
                  invalid={invalidFields.includes("locality")}
                />
              </Col>
            </Row>
            {longitudeField && latitudeField && isGoogleLoaded && (
              <GoogleMap
                mapContainerStyle={{ width: "100%", height: "350px" }}
                center={{ lat: latitudeField, lng: longitudeField }}
                zoom={18}
                onClick={onMapClick}
                options={{ streetViewControl: false }}
              >
                <Marker
                  position={marker}
                  draggable={true}
                  onDragEnd={onMapClick}
                />
              </GoogleMap>
            )}
          </>
        )}
        {currentStep === "fiscal_address" && (
          <>
            <StyledH5>Perfil fiscal</StyledH5>
            <FiscalAdress
              isItSelectable={true}
              currentSelected={fiscalAdressId}
              setSelected={setFiscalAdressId}
              cardsPerRow={1}
            />
          </>
        )}
        {currentStep === "payment" && (
          <>
            <TutorialBoxText>Pagamento</TutorialBoxText>
            <StripePay
              restaurant_id={"1"}
              subscription_number={1}
              payment_method={"stripe"}
            />
          </>
        )}
        {/*
        {errorMessage && errorMessage !== "ok_status" && (
          <Row style={{ width: "100%" }}>
            <Col xs={12}>
              <ErrorMessageBox>
                <FontAwesomeIcon icon={faTriangleExclamation} /> {errorMessage}
              </ErrorMessageBox>
            </Col>
          </Row>
        )}
*/}
        {/* Navigation buttons */}
        {stepCounter > 1 && (
          <StyledArrowLeft
            icon={faCircleArrowLeft}
            onClick={handleGoBackSteps}
          />
        )}
        {stepCounter < 3 && (
          <StyledArrowRight
            icon={faCircleArrowRight}
            onClick={handleNextSteps}
          />
        )}
        {stepCounter === 3 && (
          <CreateButtom onClick={checkForErrorsAndCreateRestaurant}>
            Guardar
          </CreateButtom>
        )}

        <TutorialBoxMiddleSteps>Passo {stepCounter} / 3</TutorialBoxMiddleSteps>

        <TutorialSteps
          showModal={showStepsModal}
          step={currentStep}
          setShowModalFalse={handleCloseStepsModal}
        />

        {showConfirmExit && (
          <>
            <ModalOverlay />
            <ConfirmationModal
              show={showConfirmExit}
              onHide={() => setShowConfirmExit(false)}
              centered
            >
              <div className="modal-header">
                <h5 className="modal-title">Cancelar criação?</h5>
                <CloseIcon
                  icon={faXmark}
                  onClick={() => setShowConfirmExit(false)}
                  role="button"
                  tabIndex="0"
                  style={{ color: "white" }}
                />
              </div>

              <div className="modal-body">
                Tem certeza que deseja sair? As informações podem ser perdidas.
              </div>

              <div className="modal-footer">
                <ModernButton
                  color="#99b0ad"
                  fontSize="14px"
                  onClick={() => setShowConfirmExit(false)}
                >
                  Cancelar
                </ModernButton>

                <ModernButton
                  color="#ff704d"
                  fontSize="14px"
                  onClick={() => setRestauranteCreationModal(false)}
                >
                  Confirmar
                </ModernButton>
              </div>
            </ConfirmationModal>
          </>
        )}
      </TutorialBoxContent>
    </TutorialBox>
  );
}

export default RestaurantCreation;
